// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '234aef3c-26ae-4a28-bec6-f7651086ea4f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 1,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Title_Background_Half',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ed28391b-051c-4003-be83-18bee5285a7c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 1,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Title_Background_Half',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd8dcfc26-485d-4374-a623-4b3ca789b205',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'WHEEL',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 85,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffe03d',
        stroke: '#ad2331',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'FORTUNA',
          style: {
            fontSize: 63
          },
          y: 26
        },
        fr_FR: {
          text: 'CHANCE',
          style: {
            fontSize: 73
          },
          y: 20
        },
        de_DE: {
          visible: false
        },
        es_ES: {
          text: 'SUERTE',
          style: {
            fontSize: 78
          },
          y: 21
        },
        pt_PT: {
          text: 'FORTUNA',
          style: {
            fontSize: 62
          },
          y: 25
        },
        pl_PL: {
          text: 'FORTUNY',
          style: {
            fontSize: 63
          },
          y: 23
        },
        nl_NL: {
          text: 'FORTUIN',
          style: {
            fontSize: 67
          },
          y: 23
        },
        ko_KR: {
          text: '럭키 휠',
          style: {
            fontWeight: 'bolder'
          },
          y: 9
        },
        ja_JP: {
          text: 'ホイール',
          style: {
            fontWeight: 'bolder',
            fontSize: 60,
            letterSpacing: -10
          },
          y: 26
        }
      }
    },
    {
      id: '9570981d-cb64-4b5d-99f2-515d848edd6c',
      type: 'Text',
      name: '',
      className: '',
      x: 20,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lucky',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 104,
        fontWeight: 'normal',
        fontFamily: 'BillionDreams{wf}',
        fill: 'white',
        stroke: '#ad2331',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 20,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'Ruota',
          y: -56
        },
        fr_FR: {
          text: 'Roue',
          y: -63,
          style: {
            letterSpacing: 0,
            fontSize: 116
          }
        },
        de_DE: {
          text: 'Glücksrad',
          y: 11,
          style: {
            fontSize: 90,
            padding: 15,
            fill: '#ffe03d'
          },
          x: 20
        },
        es_ES: {
          text: 'Ruleta',
          y: -58,
          style: {
            padding: 20,
            fontSize: 100
          }
        },
        pt_PT: {
          text: 'Roda',
          y: -47
        },
        pl_PL: {
          text: 'Koło',
          y: -30
        },
        nl_NL: {
          text: 'Rad',
          y: -42,
          x: 17
        },
        ko_KR: {
          visible: false
        },
        ja_JP: {
          text: 'ラッキー',
          style: {
            fontWeight: 'bolder',
            fontSize: 60,
            letterSpacing: -10
          },
          y: -34
        }
      }
    },
    {
      id: '8811af9c-c6b6-4001-9f45-5c30c3f9c77f',
      type: 'Text',
      name: '',
      className: '',
      x: 20,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'della',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'BillionDreams{wf}',
        fill: 'white',
        stroke: '#ad2331',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 20,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'della',
          visible: true,
          y: -15
        },
        fr_FR: {
          visible: true,
          y: -5,
          text: 'de la',
          x: 35
        },
        es_ES: {
          visible: true,
          text: 'de la',
          y: -5,
          style: {
            padding: 20
          }
        },
        pt_PT: {
          visible: true,
          text: 'da',
          y: 2
        },
        nl_NL: {
          text: 'van',
          visible: true,
          y: 3,
          x: 40
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'en_US',
    'it_IT',
    'fr_FR',
    'de_DE',
    'es_ES',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP'
  ],
  handleResize: false
} as const;

export class LuckyWheelTitleLocalizationsLayout {
  static raw = raw;
  root!: Container;
  locaSkin_SPL!: (Container)[];
  StateName!: 'en_US' | 'it_IT' | 'fr_FR' | 'de_DE' | 'es_ES' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'ja_JP';

  constructor() {
    populate(this, raw);
  }
}
